function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useContext, useEffect, useState } from "react";
import { useFloating, flip, getOverflowAncestors } from "@floating-ui/react";
import { debounce } from "../private/helpers";
import PortalContext from "../private/Portal/PortalContext";
var usePopper = _ref => {
  var {
    placement = "bottom",
    middleware = [flip()],
    mounted,
    setWidth,
    floatingUiProps
  } = _ref;
  var [referenceWidth, setReferenceWidth] = useState(null);
  var computeWidth = {
    name: "computeWidth",
    fn: _ref2 => {
      var {
        rects
      } = _ref2;
      setReferenceWidth(rects.reference.width);
      return {};
    }
  };
  var {
    update,
    refs,
    context,
    floatingStyles,
    placement: internalPlacement
  } = useFloating(_extends({
    placement,
    middleware: setWidth ? [computeWidth, ...middleware] : middleware,
    transform: false
  }, floatingUiProps));
  var {
    portals
  } = useContext(PortalContext);
  useEffect(() => {
    var referenceRef = refs.reference.current;
    var floatingRef = refs.floating.current;
    if (!mounted || !floatingRef || !referenceRef) {
      return;
    }
    var isElement = item => "className" in item;
    var parents = [...getOverflowAncestors(referenceRef)];
    var elementsToObserve = [...parents.filter(isElement), referenceRef, floatingRef, ...portals.filter(portal => portal.floating.contains(referenceRef)).map(portal => portal.floating)];
    var [debounceFunc] = debounce(() => {
      requestAnimationFrame(() => {
        update();
      });
    }, {
      leading: true
    });
    parents.forEach(parent => {
      parent.addEventListener("scroll", debounceFunc);
    });
    var resizeObserver = new ResizeObserver(debounceFunc);
    elementsToObserve.forEach(parent => {
      resizeObserver.observe(parent);
    });
    window.addEventListener("resize", debounceFunc);
    return () => {
      parents.forEach(parent => {
        parent.removeEventListener("scroll", debounceFunc);
      });
      elementsToObserve.forEach(parent => {
        resizeObserver.unobserve(parent);
      });
      window.removeEventListener("resize", debounceFunc);
    };
  }, [mounted, update, refs.floating, refs.reference, setWidth, portals]);
  return {
    popperRef: refs.setFloating,
    popperStyle: _extends({}, floatingStyles, setWidth && (referenceWidth ? {
      width: referenceWidth + "px"
    } : {
      width: 0,
      overflow: "hidden"
    })),
    placement: internalPlacement,
    refs,
    context
  };
};
export default usePopper;